module.exports = __webpack_public_path__ + "img/safe.79099bf3.png";